import { render, staticRenderFns } from "./examGroups.vue?vue&type=template&id=33e4663a&"
import script from "./examGroups.vue?vue&type=script&lang=js&"
export * from "./examGroups.vue?vue&type=script&lang=js&"
import style0 from "./examGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports